import { SaDTO, PassDTO, AsylumDTO } from "@core/models/dto.models";
import { IdentificationDocument } from "@core/models/registration.interface";

export const getIdentificationDetail = (
  indentification: IdentificationDocument
): SaDTO | PassDTO | AsylumDTO => {
  switch (indentification.type) {
    case "I": {
      return {
        idNumber: indentification.idNumber,
        country: indentification.country,
        type: indentification.type,
      } as SaDTO;
    }
    case "P": {
      return {
        passportNumber: indentification.idNumber,
        country: indentification.country,
        type: indentification.type,
      } as PassDTO;
    }

    case "A": {
      return {
        asylumNumber: indentification.idNumber,
        country: indentification.country,
        type: indentification.type,
      } as AsylumDTO;
    }

    default:
      return {} as SaDTO;
  }
};

export const isValueEmptyOrNull = (value: string | null) => {
  // !value?.trim() negatively matches empty strings and strings made of only spaces

  if (!value) {
    return true;
  } else if (!value.trim()) {
    return true;
  } else {
    return false;
  }
};